import Handlebars from "../handlebars/handlebars";
import categoryListHtml from "./categoryList.hbs"

const categoryListContainer = document.querySelector('.js--element-categoryList')
const categoryId = window.spdc.categoryId;
const state = {
    categoryList: {},
    productsPerRow: '',
}

Collaterate.Site.getCategoryById(categoryId)
    .then(category => state.categoryList = category)
    .then(initView)
    .then(renderCategoryList)
    .then(() => sendGa4ListViewEvent(state.categoryList))

function getProducts (category) {
    return category.children.length
        ? category.children.reduce((arr, categoryItem) => [...arr, ...categoryItem.products], [])
        : category.products;
}

function sendGa4ListViewEvent (category) {
    const products = getProducts(category);

    gtag("event", "view_item_list", {
        item_list_id: category.id.toString(),
        item_list_name: category.name,
        items: products.map((item, index) => ({
            item_id: `SLS_${item.id}`,
            item_name: item.name,
            index: index,
            item_brand: "Smartpress",
            item_category: category.name
        }))
    });
}

function initView () {
    categoryListContainer.addEventListener('click', handleItemClick);
}

function handleItemClick (e) {
    const featureTile = e.target.closest('.featureTile');

    if (!featureTile) {
        return;
    }

    const item = state.categoryList.products.find(product => product.id === Number(featureTile.dataset.productId))

    item && gtag('event', 'select_item', {
        item_list_id: state.categoryList.id.toString(),
        item_list_name: state.categoryList.name,
        items: [
            {
                item_id: `SLS_${item.id}`,
                item_name: item.name,
                item_brand: "Smartpress",
                item_category: state.categoryList.name
            }
            ]
    });
}

function renderCategoryList () {
    categoryListContainer.innerHTML = categoryListHtml(state);
    setTimeout( () => {
        window.location.href.includes('#') && window.location.replace(window.location.href);
    }, 500)
    
}